import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { duration, easeOut, rise } from '@/lib/motion'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
    y?: number
    amount?: number
}

// Fade plus a small rise, once, as the block enters the viewport. Reduced motion keeps the fade and drops the movement.
export const Reveal: FC<RevealProps> = ({
    children,
    className,
    delay = 0,
    y = rise.md,
    amount = 0.2
}): ReactNode => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount }}
            transition={{
                default: { duration: duration.slow, ease: easeOut, delay },
                opacity: { duration: duration.base, ease: easeOut, delay }
            }}
        >
            {children}
        </motion.div>
    )
}
